export interface AnimeItem {
  id: string;
  title: string;
  titleEn: string;
  category: '甜番' | '纯爱' | '狗粮' | '暧昧';
  tags: string[];
  episodes: string;
  year: string;
  sweetness: number;
  rating: string;
  status: string;
  desc: string;
  reason: string;
  image: string;
}

export interface RankingItem {
  id: string;
  title: string;
  category: '甜番' | '纯爱' | '狗粮' | '暧昧';
  tagline: string;
  sweetness: number;
  heat: string;
  image: string;
}

export interface Testimonial {
  id: string;
  name: string;
  tag: string;
  quote: string;
  avatar: string;
}

export interface Faq {
  id: string;
  q: string;
  a: string;
}

export const categoryMeta = [
  { key: '甜番', label: '高甜狗粮番', icon: 'ri-cake-3-line', count: 32, desc: '糖分爆表，看完牙都疼，适合被治愈到想谈恋爱的时候。' },
  { key: '纯爱', label: '纯爱治愈番', icon: 'ri-ink-bottle-line', count: 28, desc: '细水长流的喜欢与陪伴，安静治愈，慢慢心动不着急。' },
  { key: '狗粮', label: '狗粮日常番', icon: 'ri-hearts-line', count: 24, desc: '两个人甜甜腻腻的日常，情侣互动管够，单身慎入。' },
  { key: '暧昧', label: '暧昧拉扯番', icon: 'ri-flashlight-line', count: 19, desc: '欲言又止、脸红心跳，拉扯期的心动最让人上头。' },
];

export const animeList: AnimeItem[] = [
  {
    id: 'strawberry-soda',
    title: '草莓汽水约定',
    titleEn: 'Strawberry Soda Promise',
    category: '甜番',
    tags: ['校园', '青梅竹马', '夏日'],
    episodes: '24 集',
    year: '2026',
    sweetness: 5,
    rating: '9.4',
    status: '已完结',
    desc: '两个从小一起长大的邻居，在烟火大会上因为一杯草莓汽水，突然意识到「不想再只做朋友」。全程高甜，告白名场面让人反复回味。',
    reason: '糖分拉满且节奏轻快，适合想无脑磕糖的一天。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20cheerful%20summer%20festival%20scene%2C%20two%20teenagers%20sharing%20strawberry%20soda%20under%20warm%20lantern%20light%2C%20vibrant%20pink%20and%20coral%20color%20palette%2C%20stalls%20with%20glowing%20string%20lights%20in%20soft%20focus%20background%2C%20sparkles%20and%20bokeh%2C%20sweet%20youthful%20romance%20mood%2C%20clean%20modern%20anime%20key%20visual%2C%20high%20quality%20digital%20art&width=800&height=600&seq=anime-strawberry&orientation=landscape',
  },
  {
    id: 'sakura-glow',
    title: '樱花微光',
    titleEn: 'Sakura Glow',
    category: '纯爱',
    tags: ['青春', '治愈', '慢热'],
    episodes: '13 集',
    year: '2025',
    sweetness: 4,
    rating: '9.1',
    status: '已完结',
    desc: '转学少女在樱花树下遇见了温柔的同桌，两个人从陌生到熟悉，用一整年慢慢靠近彼此。没有跌宕起伏，只有细碎的温柔在日常里生长。',
    reason: '治愈系纯爱天花板，适合深夜安静地慢慢看。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20serene%20spring%20scene%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20petals%20falling%20like%20rain%20on%20a%20young%20couple%20walking%20on%20a%20stone%20path%2C%20gentle%20sunlight%20through%20blossoms%2C%20pastel%20pink%20and%20white%20color%20palette%2C%20peaceful%20pure%20love%20atmosphere%2C%20clean%20modern%20anime%20key%20visual%2C%20high%20quality%20digital%20art&width=800&height=600&seq=anime-sakura&orientation=landscape',
  },
  {
    id: 'cafe-heartbeat',
    title: '心跳咖啡店',
    titleEn: 'Heartbeat Cafe',
    category: '狗粮',
    tags: ['职场', '日常', '治愈'],
    episodes: '12 集',
    year: '2026',
    sweetness: 4,
    rating: '9.0',
    status: '连载中',
    desc: '咖啡店店长和常客甜点师从互相试探到默契十足，每天在吧台前后的心动互动甜度超标。两人一起研发新品的过程，就是一部加糖日常。',
    reason: '暖色治愈+专业磕糖，看完想马上去楼下咖啡店。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20warm%20cozy%20cafe%2C%20a%20couple%20sharing%20a%20cup%20of%20cocoa%20while%20exchanging%20shy%20glances%20across%20the%20counter%2C%20golden%20afternoon%20light%20through%20windows%2C%20wooden%20interior%20with%20hanging%20plants%2C%20pastel%20warm%20color%20palette%2C%20tender%20romantic%20atmosphere%2C%20clean%20modern%20anime%20key%20visual%2C%20high%20quality%20digital%20art&width=800&height=600&seq=anime-cafe&orientation=landscape',
  },
  {
    id: 'summer-confession',
    title: '盛夏的告白',
    titleEn: 'Summer Confession',
    category: '甜番',
    tags: ['校园', '告白', '青春'],
    episodes: '18 集',
    year: '2025',
    sweetness: 5,
    rating: '9.3',
    status: '已完结',
    desc: '天台上的那声告白被晚风轻轻吹散，却又落在两个人心里。从青涩试探到双向奔赴，全程心动高能，糖点密集不拖沓。',
    reason: '告白名场面全网刷屏，属于高甜教科书级别。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20sunlit%20summer%20school%20rooftop%20at%20golden%20hour%2C%20a%20boy%20nervously%20offering%20flowers%20to%20a%20blushing%20girl%2C%20warm%20orange%20and%20coral%20light%2C%20floating%20dust%20sparkles%2C%20sweet%20high%20tension%20romantic%20moment%2C%20clean%20modern%20anime%20key%20visual%2C%20high%20quality%20digital%20art&width=800&height=600&seq=anime-summer&orientation=landscape',
  },
  {
    id: 'evening-breeze',
    title: '晚风与你的侧脸',
    titleEn: 'Evening Breeze',
    category: '纯爱',
    tags: ['治愈', '海边', '慢热'],
    episodes: '10 集',
    year: '2026',
    sweetness: 4,
    rating: '8.8',
    status: '已完结',
    desc: '在海边小镇，两个各自带着心事的年轻人因为一场晚风相遇。没有轰轰烈烈的剧情，只有并肩看日落时的默契与心动。',
    reason: '画面绝美，安静治愈，适合想放松心情时点开。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20quiet%20riverside%20at%20dusk%2C%20warm%20orange%20and%20coral%20sky%2C%20a%20boy%20and%20girl%20sitting%20on%20a%20bench%20watching%20the%20sunset%2C%20gentle%20breeze%20moving%20hair%20and%20scarf%2C%20soft%20pastel%20gradient%20sky%2C%20nostalgic%20pure%20romance%20mood%2C%20clean%20modern%20anime%20key%20visual%2C%20high%20quality%20digital%20art&width=800&height=600&seq=anime-breeze&orientation=landscape',
  },
  {
    id: 'moonlight-words',
    title: '月光下说不出口',
    titleEn: 'Words Under the Moon',
    category: '暧昧',
    tags: ['暗恋', '拉扯', '文艺'],
    episodes: '12 集',
    year: '2026',
    sweetness: 3,
    rating: '9.0',
    status: '连载中',
    desc: '天台上的两个人谁都没有先开口，只有月光替他们讲心里话。暗恋的试探、欲言又止的瞬间，把暧昧期的酸涩与心动都拍到了极致。',
    reason: '拉扯感拉满，看完心里痒痒的，后劲十足。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20quiet%20rooftop%20at%20night%20under%20a%20large%20glowing%20cream%20moon%2C%20two%20teenagers%20standing%20close%20with%20hesitant%20longing%20gazes%2C%20soft%20warm%20moonlight%20and%20rose%20tinted%20shadows%2C%20fireflies%20in%20the%20air%2C%20ambiguous%20tender%20tension%2C%20warm%20pink%20and%20gold%20palette%2C%20clean%20modern%20anime%20key%20visual%2C%20high%20quality%20digital%20art&width=800&height=600&seq=anime-moonlight&orientation=landscape',
  },
  {
    id: 'sugar-overload',
    title: '甜度超标警告',
    titleEn: 'Sugar Overload',
    category: '甜番',
    tags: ['恋爱', '高糖', '轻喜剧'],
    episodes: '16 集',
    year: '2025',
    sweetness: 5,
    rating: '9.2',
    status: '已完结',
    desc: '一见面就斗嘴的冤家，意外在同一家公司成为搭档。从互相看不顺眼到忍不住心动，每一集都是糖分超标的爆笑甜恋。',
    reason: '下饭神器，甜和笑点齐飞，看完心情瞬间变好。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20cozy%20dessert%20cafe%2C%20a%20couple%20sharing%20a%20strawberry%20crepe%20cake%20with%20cream%2C%20warm%20rose%20pink%20interior%2C%20fairy%20lights%20and%20soft%20golden%20glow%2C%20cute%20romantic%20expressions%2C%20pastel%20pink%20and%20peach%20color%20scheme%2C%20sweet%20dreamy%20atmosphere%2C%20clean%20modern%20anime%20key%20visual%2C%20high%20quality%20digital%20art&width=800&height=600&seq=anime-sugar&orientation=landscape',
  },
  {
    id: 'galaxy-station',
    title: '银河车站恋曲',
    titleEn: 'Galaxy Station Romance',
    category: '纯爱',
    tags: ['奇幻', '治愈', '幻想'],
    episodes: '13 集',
    year: '2026',
    sweetness: 4,
    rating: '9.0',
    status: '连载中',
    desc: '少女在末班电车上误入通往银河的车站，遇见会等的男孩。时空交错的设定下，两个人用一次次道别与重逢，讲述最温柔的长情告白。',
    reason: '浪漫到冒泡泡的幻想纯爱，画风和配乐都很加分。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20dreamy%20night%20train%20station%20under%20a%20glowing%20warm%20pink%20and%20peach%20galaxy%20with%20soft%20stars%2C%20two%20characters%20standing%20on%20a%20platform%20under%20warm%20golden%20lamps%2C%20floating%20light%20particles%2C%20romantic%20fantastical%20mood%2C%20warm%20rose%20and%20gold%20color%20palette%2C%20clean%20modern%20anime%20key%20visual%2C%20high%20quality%20digital%20art&width=800&height=600&seq=anime-galaxy&orientation=landscape',
  },
  {
    id: 'lemon-seat',
    title: '邻座的柠檬',
    titleEn: 'Lemon Next Door',
    category: '暧昧',
    tags: ['校园', '暗恋', '青春'],
    episodes: '15 集',
    year: '2025',
    sweetness: 3,
    rating: '8.7',
    status: '已完结',
    desc: '总是递纸条、借橡皮、偷偷看你的那个邻座，其实早就在心里准备了一场盛大告白。青涩的暗恋细节，每一帧都像回到了学生时代。',
    reason: '暗恋视角太真实，代入感极强，看到结局会心一笑。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20bright%20classroom%2C%20a%20girl%20passing%20a%20note%20to%20the%20boy%20sitting%20next%20to%20her%20by%20the%20window%2C%20sunbeams%20streaming%20in%2C%20soft%20coral%20and%20cream%20tones%2C%20school%20uniform%2C%20innocent%20youthful%20crush%20mood%2C%20warm%20pastel%20palette%2C%20clean%20modern%20anime%20key%20visual%2C%20high%20quality%20digital%20art&width=800&height=600&seq=anime-lemon&orientation=landscape',
  },
];

export const rankingList: RankingItem[] = [
  {
    id: 'r1',
    title: '草莓汽水约定',
    category: '甜番',
    tagline: '烟火下的告白，甜到失语',
    sweetness: 5,
    heat: '9.4',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20cheerful%20summer%20festival%20scene%2C%20two%20teenagers%20sharing%20strawberry%20soda%20under%20warm%20lantern%20light%2C%20vibrant%20pink%20and%20coral%20color%20palette%2C%20stalls%20with%20glowing%20string%20lights%20in%20soft%20focus%20background%2C%20sparkles%20and%20bokeh%2C%20sweet%20youthful%20romance%20mood%2C%20clean%20modern%20anime%20key%20visual%2C%20high%20quality%20digital%20art&width=800&height=600&seq=anime-strawberry&orientation=landscape',
  },
  {
    id: 'r2',
    title: '盛夏的告白',
    category: '甜番',
    tagline: '天台告白名场面，全网心动',
    sweetness: 5,
    heat: '9.3',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20sunlit%20summer%20school%20rooftop%20at%20golden%20hour%2C%20a%20boy%20nervously%20offering%20flowers%20to%20a%20blushing%20girl%2C%20warm%20orange%20and%20coral%20light%2C%20floating%20dust%20sparkles%2C%20sweet%20high%20tension%20romantic%20moment%2C%20clean%20modern%20anime%20key%20visual%2C%20high%20quality%20digital%20art&width=800&height=600&seq=anime-summer&orientation=landscape',
  },
  {
    id: 'r3',
    title: '月光下说不出口',
    category: '暧昧',
    tagline: '拉扯感拉满，后劲十足',
    sweetness: 3,
    heat: '9.0',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20quiet%20rooftop%20at%20night%20under%20a%20large%20glowing%20cream%20moon%2C%20two%20teenagers%20standing%20close%20with%20hesitant%20longing%20gazes%2C%20soft%20warm%20moonlight%20and%20rose%20tinted%20shadows%2C%20fireflies%20in%20the%20air%2C%20ambiguous%20tender%20tension%2C%20warm%20pink%20and%20gold%20palette%2C%20clean%20modern%20anime%20key%20visual%2C%20high%20quality%20digital%20art&width=800&height=600&seq=anime-moonlight&orientation=landscape',
  },
  {
    id: 'r4',
    title: '甜度超标警告',
    category: '甜番',
    tagline: '糖点密集，下饭必备',
    sweetness: 5,
    heat: '9.2',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20cozy%20dessert%20cafe%2C%20a%20couple%20sharing%20a%20strawberry%20crepe%20cake%20with%20cream%2C%20warm%20rose%20pink%20interior%2C%20fairy%20lights%20and%20soft%20golden%20glow%2C%20cute%20romantic%20expressions%2C%20pastel%20pink%20and%20peach%20color%20scheme%2C%20sweet%20dreamy%20atmosphere%2C%20clean%20modern%20anime%20key%20visual%2C%20high%20quality%20digital%20art&width=800&height=600&seq=anime-sugar&orientation=landscape',
  },
  {
    id: 'r5',
    title: '樱花微光',
    category: '纯爱',
    tagline: '治愈系纯爱天花板',
    sweetness: 4,
    heat: '9.1',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20serene%20spring%20scene%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20petals%20falling%20like%20rain%20on%20a%20young%20couple%20walking%20on%20a%20stone%20path%2C%20gentle%20sunlight%20through%20blossoms%2C%20pastel%20pink%20and%20white%20color%20palette%2C%20peaceful%20pure%20love%20atmosphere%2C%20clean%20modern%20anime%20key%20visual%2C%20high%20quality%20digital%20art&width=800&height=600&seq=anime-sakura&orientation=landscape',
  },
];

export const testimonialList: Testimonial[] = [
  {
    id: 't1',
    name: '一只软糖',
    tag: '高甜党',
    quote: '本来只想找部下饭番，结果被「草莓汽水约定」甜到在床上打滚。这个站的口味分类太准了，一看一个准。',
    avatar: 'ri-heart-3-line',
  },
  {
    id: 't2',
    name: '晚风不晚',
    tag: '纯爱党',
    quote: '一直想找那种安静治愈的恋爱番，这里推荐的「晚风与你的侧脸」完全长在我的审美上，画面和故事都好温柔。',
    avatar: 'ri-sparkling-2-line',
  },
  {
    id: 't3',
    name: '柠檬汽水',
    tag: '暧昧党',
    quote: '喜欢拉扯感强的番，点名「月光下说不出口」，看完后劲太大，好几天都缓不过来。更新得再快一点！',
    avatar: 'ri-moon-clear-line',
  },
  {
    id: 't4',
    name: '今天也想磕',
    tag: '狗粮党',
    quote: '榜单很靠谱，甜度测评基本没踩过雷。狗粮区每一部都让我边吃糖边露出姨母笑，已经安利给闺蜜了。',
    avatar: 'ri-empathize-line',
  },
];

export const faqList: Faq[] = [
  {
    id: 'f1',
    q: '这些恋爱甜番在哪里可以观看？',
    a: '我们推荐的甜番多为正版平台可观看的日常恋爱向动画，常见的视频平台通常都有收录。具体片源请以平台实时播放情况为准。',
  },
  {
    id: 'f2',
    q: '收录的番剧是纯爱向还是成人向？',
    a: '羞羞的动漫主要收录纯爱、甜番、狗粮与暧昧心动的恋爱题材，以温馨治愈的心动氛围为主，不包含不适合公开展示的成人向内容。',
  },
  {
    id: 'f3',
    q: '多久更新一次推荐列表？',
    a: '推荐合集会持续更新，一般每周补充新番和整理心动榜单，订阅后可第一时间收到更新通知。',
  },
  {
    id: 'f4',
    q: '如何快速找到适合自己口味的甜番？',
    a: '可以按高甜番、纯爱番、狗粮番和暧昧番四种口味分类浏览，也可以参考甜度测评与心动榜单快速定位。',
  },
  {
    id: 'f5',
    q: '榜单和甜度测评是怎么来的？',
    a: '甜度测评综合剧情糖分、互动浓度、心动名场面和观众口碑综合给出，榜单则根据近期热度与讨论度整理。',
  },
  {
    id: 'f6',
    q: '会收录尚未完结的连载番吗？',
    a: '会，但我们会明确标注连载状态，方便你根据是否想一口气看完来选择。',
  },
];